import SanityClient from '@sanity/client';

export default SanityClient({
	projectId: 'u6kquijx',
	dataset: 'production',
});
// useCdn: true,
